// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgThumbsUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.479 5.143a9.017 9.017 0 0 1-1.012 2.78c-.634 1.022-2.239 1.824-3.61 2.363-.786.306-1.588.568-2.404.785l-.113.024v7.964l.076.042c.106.061 4.025 1.47 5.077 1.47h6.964a1.44 1.44 0 0 0 .843-2.602 1.44 1.44 0 0 0 .586-2.585 1.44 1.44 0 0 0 .587-2.585 1.44 1.44 0 0 0-.254-2.856h-4.848c.281-1.029 1.471-5.578-.566-6.432a.923.923 0 0 0-.343-.082c-.6 0-.76.723-.984 1.714zm.984-2.458c.227 0 .451.05.658.144 2.119.894 1.721 4.24 1.227 6.36h3.868a2.201 2.201 0 0 1 1.42 3.884 2.201 2.201 0 0 1-.587 2.589 2.197 2.197 0 0 1-.586 2.585 2.198 2.198 0 0 1-2.006 3.086H9.493c-1.22 0-5.214-1.437-5.451-1.567l-.072-.041-.39-.22v-9l.582-.14.11-.024c.786-.2 1.56-.448 2.317-.741 1.67-.651 2.822-1.371 3.24-2.057a8.339 8.339 0 0 0 .92-2.575c.229-1.08.507-2.3 1.713-2.3z"
    />
  </svg>
);
export default SvgThumbsUp;
